export const defaultColumns = [
  {
    Header: 'SEO Traffic Value',
    accessor: 'traffic_value',
    disableSortBy: true
  },
  {
    Header: 'Organic Search Traffic',
    accessor: 'search_traffic',
    disableSortBy: true
  }
];

export const tagColumns = [
  {
    Header: 'Story Topic',
    accessor: 'subject',
    disableSortBy: true
  },
  ...defaultColumns
];

export const pillarColumns = [
  {
    Header: 'Pillar',
    accessor: 'subject',
    disableSortBy: true
  },
  ...defaultColumns
];

export const audienceColumns = [
  {
    Header: 'Audience',
    accessor: 'subject',
    disableSortBy: true
  },
  ...defaultColumns
];

export const convertStoryTopicsToArr = tableInfo => {
  const storyTopics = [];
  tableInfo.map(objs => {
    const tagInfoKeys = Object.keys(objs);
    return storyTopics.push(tagInfoKeys);
  });
  return storyTopics.flat();
};

export const createTagData = (tagInfo, topic) => {
  const [tableTagData] = tagInfo.filter(obj => Object.keys(obj)[0] === topic);
  const columnArr = tableTagData[topic];
  if (columnArr.length < 1) {
    columnArr.push({
      subject: `No Tags`,
      search_traffic: 0,
      traffic_value: '$0'
    });
  }
  return columnArr;
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/tableConfig.js